import React from "react"

const FAQPage = ({ asks }) => {

    let questions = [];

    asks.map(function(value, index) {
        let new_item = {
            "@type": "Question",
            "name": value.questionText,
            "acceptedAnswer": {
                "@type": "Answer",
                "text": value.responseText
            }
        };
        questions.push(new_item);
    });

    const ldjson = {
        "@context": "http://schema.org",
        "@type": "FAQPage",
        "mainEntity": questions
    };

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(ldjson) }}
        />
    )
}

export default FAQPage